export default async function fetchWithAuth(url, options = {}) {
  const jwt = localStorage.getItem('jwt');
  const headers = {
    ...(options.headers || {}),
    ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
  };
  const response = await fetch(url, { ...options, headers });

  // Check for expired token error
  if (response.headers.get('content-type')?.includes('application/json')) {
    const clone = response.clone();
    const data = await clone.json().catch(() => null);
    if (
      data &&
      data.error === "Token inválido o expirado" &&
      data.details === "jwt expired"
    ) {
      localStorage.removeItem('user');
      localStorage.removeItem('jwt');
      // Optionally, force reload to show login
      window.location.reload();
      // Or, you can throw a special error and handle it in your components
    }
  }

  return response;
}